import { Base } from '@master/model/Base'
import { Ignore } from '@master/annotation/Ignore'
import { Pointer } from '@master/annotation/Pointer'
import Recommendation from '@master/model/kyc-form/Recommendation'

export const RiskRatingOptions = ['LOW', 'MEDIUM', 'HIGH', 'REJECTED/STR'] as const
export default class AML extends Base {
  @Ignore()
  customType = ''

  adverseDBChecks = ''
  redFlag = ''
  sanctioned = ''
  financialFlowHighRisk = ''
  pepAssociated = ''
  transactValueBelowThreshold = '' // set by custom pointer
  applyMedicalProduct = '' // set by custom pointer

  presenceAccOpen = ''
  comments = ''

  riskRating: typeof RiskRatingOptions[number] = 'LOW'

  dateOfAssessment: string | number = ''

  @Ignore()
  @Pointer('ROOT', 'recommendations')
  rcmd: Recommendation = new Recommendation(null)

  @Ignore()
  @Pointer('personalDetails', 'isSingaporean')
  isSingaporean = 'no'

  @Ignore()
  @Pointer('personalDetails', 'isHighRiskPR')
  isHighRiskPR = 'no'

  @Ignore()
  @Pointer('personalDetails', 'isHighRiskForeign')
  isHighRiskForeign = 'no'

  @Ignore()
  transactThreshold = 30000

  constructor (type: 'client_0' | 'client_1' = 'client_0') {
    super()
    this.customType = type + '_aml'
  }

  get transactionValue () {
    const clientIndex = this.customType === 'client_0_aml' ? 1 : 2
    return this.rcmd['c' + clientIndex + 'TransactValue']
  }

  // custom method to extract since aml is a single object packed with the properties
  extractData (rawKycForm) {
    return super.extractData(rawKycForm[this.customType])
  }

  afterExtractData (data: any) {
    Object.defineProperty(this, 'applyMedicalProduct', {
      get: () => {
        return this.customType === 'client_0_aml' ? this.rcmd.c1hasMedical : this.rcmd.c2hasMedical // TODO: tmp disable
      },
      set: () => {
        // inserted here to resolve issue when admin approve
        // error : 'Cannot set Property which has only a Getter'
      }
    })
    Object.defineProperty(this, 'transactValueBelowThreshold', { // TODO: tmp disable
      get: () => {
        const tv = this.customType === 'client_0_aml' ? this.rcmd.c1TransactValue : this.rcmd.c2TransactValue
        return tv <= this.transactThreshold ? 'yes' : 'no'
      }
    })
    return data
  }

  convertToRawData () {
    this.dateOfAssessment = Date.now()
    const results = super.convertToRawData()
    return {
      [this.customType]: results
    }
  }

  get isHighRisk () {
    return Object.keys(this).some(key => {
      return ['adverseDBChecks', 'redFlag', 'sanctioned', 'financialFlowHighRisk', 'pepAssociated'].includes(key) && this[key] === 'yes'
    })
  }

  // allow user to edit the risk rating
  @Ignore()
  get suggestedRiskRating (): (typeof RiskRatingOptions[number] | '')[] {
    const highRisk = this.isHighRisk
    if (highRisk) return ['HIGH', 'REJECTED/STR']
    const medRisk = this.isHighRiskPR === 'yes' || this.isHighRiskForeign === 'yes'
    if (medRisk) return ['MEDIUM']
    const lowRisk = this.transactValueBelowThreshold === 'yes' || this.applyMedicalProduct === 'yes' || this.isSingaporean === 'yes'
    if (lowRisk) return ['LOW'] // otherwise is always low
  }
}
